import React from 'react';
import { useAuth } from '../../context/AuthContext';
import ClientLayout from '../../components/ClientLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { User, Building, Bell, Shield } from 'lucide-react';

const SettingsPage = () => {
  const { user } = useAuth();

  return (
    <ClientLayout title="Settings">
      <div className="max-w-3xl space-y-6">
        {/* Profile Settings */}
        <Card className="border-gray-200">
          <CardHeader>
            <div className="flex items-center gap-3">
              <User className="h-5 w-5 text-primary" />
              <CardTitle className="text-lg">Profile Settings</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <Label>Name</Label>
                <Input defaultValue={user?.name} disabled />
              </div>
              <div>
                <Label>Email</Label>
                <Input defaultValue={user?.email} disabled />
              </div>
            </div>
            <div>
              <Label>Role</Label>
              <Input defaultValue={user?.role} disabled className="capitalize" />
            </div>
          </CardContent>
        </Card>

        {/* Company Settings */}
        <Card className="border-gray-200">
          <CardHeader>
            <div className="flex items-center gap-3">
              <Building className="h-5 w-5 text-primary" />
              <CardTitle className="text-lg">Company Settings</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label>Company Name</Label>
              <Input placeholder="Your Company Name" />
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <Label>Phone</Label>
                <Input placeholder="(555) 123-4567" />
              </div>
              <div>
                <Label>Email</Label>
                <Input placeholder="contact@company.com" />
              </div>
            </div>
            <div>
              <Label>Address</Label>
              <Input placeholder="123 Business St, City, State 12345" />
            </div>
            <Button className="bg-primary hover:bg-primary/90">Save Changes</Button>
          </CardContent>
        </Card>

        {/* Notification Settings */}
        <Card className="border-gray-200">
          <CardHeader>
            <div className="flex items-center gap-3">
              <Bell className="h-5 w-5 text-primary" />
              <CardTitle className="text-lg">Notification Preferences</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {[
                { label: 'Email notifications for new jobs', checked: true },
                { label: 'SMS alerts for route changes', checked: false },
                { label: 'Daily summary emails', checked: true },
                { label: 'Invoice payment notifications', checked: true }
              ].map((item, index) => (
                <div key={index} className="flex items-center justify-between py-2">
                  <span className="text-gray-700">{item.label}</span>
                  <input 
                    type="checkbox" 
                    defaultChecked={item.checked}
                    className="rounded border-gray-300 text-primary focus:ring-primary"
                  />
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Security Settings */}
        <Card className="border-gray-200">
          <CardHeader>
            <div className="flex items-center gap-3">
              <Shield className="h-5 w-5 text-primary" />
              <CardTitle className="text-lg">Security</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label>Current Password</Label>
              <Input type="password" placeholder="••••••••" />
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <Label>New Password</Label>
                <Input type="password" placeholder="••••••••" />
              </div>
              <div>
                <Label>Confirm New Password</Label>
                <Input type="password" placeholder="••••••••" />
              </div>
            </div>
            <Button variant="outline">Change Password</Button>
          </CardContent>
        </Card>
      </div>
    </ClientLayout>
  );
};

export default SettingsPage;
